(function() {
    'use strict';
    /*
     * Copyright (c) 2015 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhViewEditMedia', ihhViewEditMedia);

    /**
     * A directive for displaying media in read mode and adding upload and delete buttons in edit mode. Intended for use with
     * controllers that derive from {@link ihh-common-web.ViewEditCtrlBase}.
     * @ngdoc directive
     * @name ihh-view-edit-media
     * @memberOf ihh-common-web
     * @example
     * <ihh-view-edit-media
     *    control-id="some-id"
     *    edit-flag="isEdit"
     *    is-required="true"
     *    label="Name"
     *    model="foo.name"
     *    model-edit="fooTemp.name">
     * </ihh-view-edit-media>
     */
    function ihhViewEditMedia() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * The HTML id to use for the control and label, for accessibility.
                 * @ngdoc property
                 * @name control-id
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                controlId: '@',

                /**
                 * The text to display as a label.
                 * @ngdoc property
                 * @name label
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                label: '@',

                /**
                 * If set, marks the field as required, and in edit mode displayes a visual cue that the value is required.
                 * @ngdoc property
                 * @name is-required
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                isRequired: '=',

                /**
                 * The function to remove a tag to the modelEdit
                 * @ngdoc property
                 * @name isResponsive
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                isResponsive: '=?',

                /**
                 * Whether to display the video as fill (instead of fit).
                 * @ngdoc property
                 * @name isVideoAspectFill
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                isVideoAspectFill: '=?',

                /**
                 * The scope variable used to track view and edit mode.
                 * @ngdoc property
                 * @name edit-flag
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                editFlag: '=',

                /**
                 * The text to display as a label.
                 * @ngdoc property
                 * @name noMediaUrl
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                noMediaUrl: '@',

                /**
                 * The kind of the tag to filter by.
                 * @ngdoc property
                 * @name kind
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                kind: '@',

                /**
                 * The function to add a tag to the modelEdit
                 * @ngdoc property
                 * @name chooseMedia
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                chooseMedia: '=',

                /**
                 * The function to remove a tag to the modelEdit
                 * @ngdoc property
                 * @name removeMedia
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                removeMedia: '=',

                /**
                 * The function to remove a tag to the modelEdit
                 * @ngdoc property
                 * @name getMediaUrl
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                getMediaUrl: '=',

                /**
                 * The function to remove a tag to the modelEdit
                 * @ngdoc property
                 * @name getMediaUrlParams
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                mediaUrlParams: '=',

                /**
                 * The function to remove a tag to the modelEdit
                 * @ngdoc property
                 * @name getMediaTempUrl
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                getMediaTempUrl: '=',

                /**
                 * The scope variable used as the model for displaying the text in view mode.
                 * @ngdoc property
                 * @name model
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                model: '=',

                /**
                 * The scope variable used as the model for the input field when in edit mode.
                 * @ngdoc property
                 * @name model-edit
                 * @memberOf ihh-common-web.ihh-view-edit-media
                 */
                modelEdit: '='
            },
            templateUrl: 'view-edit/view-edit-media.tpl.html',
            link: function( scope/*, elem, attrs*/ ) {
                // last chance init here
                if (scope.kind === 'video') {
                    scope.config = {
                        sources: [],
                        plugins: {
                            controls: {
                                autoHide: true,
                                autoHideTime: 2000
                            }
                        }
                    };
                    scope.$watch('model', function(model) {
                        if (model) {
                            scope.viewConfig = {
                                sources: [
                                    {
                                        src: scope.getMediaUrl(scope.model, scope.mediaUrlParams),
                                        type: 'video/mp4'
                                    }
                                ]
                            };
                        }
                    });
                    scope.$watch('modelEdit', function(modelEdit) {
                        if (modelEdit) {
                            scope.editConfig = {
                                sources: [
                                    {
                                        src: scope.getMediaTempUrl(scope.modelEdit, scope.mediaUrlParams),
                                        type: 'video/mp4'
                                    }
                                ]
                            };
                        }
                    });
                }
            },
            controller: function($scope) {
                if (angular.isUndefined($scope.isResponsive)) {
                    $scope.isResponsive = true;
                }
            }
        };
    }
})();